import { jsx as _jsx } from "react/jsx-runtime";
import { TabsActionsContext, TabsHeaderContext, TabsListContext, } from '#pplx/frontend/aether/components/Tabs/internal/useTabsStructure.js';
export function TabsHeaderProvider({ children }) {
    return _jsx(TabsHeaderContext.Provider, { value: true, children: children });
}
export function TabsListProvider({ children }) {
    return _jsx(TabsListContext.Provider, { value: true, children: children });
}
export function TabsActionsStructureProvider({ children }) {
    return _jsx(TabsActionsContext.Provider, { value: true, children: children });
}
//# sourceMappingURL=TabsStructureContext.js.map